import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { FreshCoachPage } from '~/features/coach/coach-page';

/** `?q=` carries what was typed into the palette's "Open Coach: …", for the box. */
const search = z.object({ q: z.string().optional().catch(undefined) });

function FreshCoachRoute(): ReactElement {
  const { q } = Route.useSearch();
  return <FreshCoachPage q={q ?? null} />;
}

/** A new conversation (board 11-coach-home). */
export const Route = createFileRoute('/_app/coach/')({
  validateSearch: search,
  component: FreshCoachRoute,
});
